var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWalkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 512,
    viewBox: "0 0 312 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.066 99.7363C228.941 99.7363 249.933 78.7432 249.933 52.8681C249.933 26.993 228.941 6 203.066 6C177.192 6 156.199 26.993 156.199 52.8681C156.199 78.7432 177.192 99.7363 203.066 99.7363ZM295.336 245.32L272.586 233.799L263.115 205.092C248.762 161.544 208.729 131.079 163.327 130.982C128.177 130.884 108.746 140.844 72.229 155.587C51.1388 164.082 33.8566 180.193 23.7021 200.698L17.1602 213.977C9.54429 229.405 15.6956 248.152 31.025 255.866C46.2568 263.579 64.8084 257.33 72.5219 241.903L79.0638 228.624C82.4812 221.789 88.1443 216.418 95.1744 213.587L121.342 203.041L106.501 262.31C101.423 282.62 106.891 304.198 121.049 319.724L179.535 383.581C186.565 391.295 191.545 400.571 194.083 410.628L211.952 482.2C216.15 498.897 233.139 509.149 249.836 504.95C266.532 500.752 276.784 483.762 272.586 467.065L250.91 380.164C248.371 370.107 243.392 360.733 236.361 353.117L191.935 304.589L208.729 237.509L214.1 253.62C219.274 269.34 230.405 282.327 245.051 289.747L267.801 301.269C283.033 308.983 301.585 302.734 309.298 287.306C316.817 271.977 310.665 253.034 295.336 245.32V245.32ZM71.8384 382.703C68.714 390.612 64.0273 397.739 57.9736 403.696L9.15373 452.614C-3.05124 464.819 -3.05124 484.641 9.15373 496.846C21.3587 509.051 41.0819 509.051 53.2869 496.846L111.285 438.847C117.241 432.891 121.928 425.763 125.15 417.854L138.331 384.851C84.3363 325.973 100.545 344.036 92.0499 332.417L71.8384 382.703V382.703Z",
    fill: "#062134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWalkFill);
export default __webpack_public_path__ + "static/media/ico_walk_fill.b5084510edb5646461752ec6a12090f7.svg";
export { ForwardRef as ReactComponent };